export default __webpack_public_path__ + "static/media/testimonialspat.513b5aa6.jpg";